import { render, staticRenderFns } from "./Bedrooms.vue?vue&type=template&id=4204384b&scoped=true&"
import script from "./Bedrooms.vue?vue&type=script&lang=js&"
export * from "./Bedrooms.vue?vue&type=script&lang=js&"
import style0 from "./Bedrooms.vue?vue&type=style&index=0&id=4204384b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4204384b",
  null
  
)

export default component.exports